export const debounce = (originalFunction: Function, timeoutId: number, delay: number) => {
  clearTimeout(timeoutId);
  return setTimeout(originalFunction, delay);
};
